'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { formatWorkingPeriods } from './_utils/format-working-periods.util';

import { Button } from '@/components/ui/button/button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface SearchCardClinicTabFlexProps {
  schedule: SearchPartnerData;
}

export function SearchCardClinicTabFlex({ schedule }: SearchCardClinicTabFlexProps) {
  const flexSchedule = schedule.schedulesTypes[ScheduleType.FLEX]?.[0];
  const waitingTime = flexSchedule?.waitingTime;
  const formattedPeriods = formatWorkingPeriods(flexSchedule?.workingPeriods ?? []);

  const hasInfo = Boolean(waitingTime || formattedPeriods);

  return (
    <div className="flex flex-col gap-2" data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_TAB_FLEX}>
      <div>
        <Typography
          variant={TypographyVariant.MEDIUM_BODY_TEXT}
          data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_FLEX_DESCRIPTION}
        >
          Após a compra, agende seu horário diretamente com a clínica ou profissional, conforme disponibilidade.
        </Typography>

        {hasInfo && (
          <div className="mt-5 flex flex-col">
            {waitingTime && (
              <Typography
                variant={TypographyVariant.MEDIUM_BODY_TEXT}
                data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_FLEX_WAITING_TIME}
              >
                <Typography as="span" variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-bold">
                  Tempo de encaixe:
                </Typography>
                {' '}
                {waitingTime}
                {' '}
                {Number(waitingTime) === 1 ? 'dia' : 'dias'}
              </Typography>
            )}
            {formattedPeriods && (
              <Typography
                variant={TypographyVariant.MEDIUM_BODY_TEXT}
                data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_FLEX_WORKING_HOURS}
              >
                <Typography as="span" variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-bold">
                  Horário de funcionamento:
                </Typography>
                {' '}
                {formattedPeriods}
              </Typography>
            )}
          </div>
        )}
      </div>

      <Button
        className="py-2"
        data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_FLEX_CONTINUE_BUTTON}
      >
        Continuar compra
      </Button>
    </div>
  );
}
